import { render, staticRenderFns } from "./CardEnergyEfficiency.vue?vue&type=template&id=0b8a9e79&scoped=true&"
import script from "./CardEnergyEfficiency.vue?vue&type=script&lang=js&"
export * from "./CardEnergyEfficiency.vue?vue&type=script&lang=js&"
import style0 from "./CardEnergyEfficiency.vue?vue&type=style&index=0&id=0b8a9e79&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8a9e79",
  null
  
)

export default component.exports